import { useState, useEffect } from 'react';
import {Switch, TextField, FormControlLabel, Snackbar, Alert } from '@mui/material';
import getHelper from '../helpers/getHelper';
import postHelper from '../helpers/postHelper';
import configs from '../helpers/configs';

export default function Settings() {
  const [stopLoss, setStopLoss] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });  
  const { baseUrl } = configs;
  
  useEffect(() => {
    const fetchGeneralSettings = async () => {
      try {
        const [ordersCheckerRule, settings] = await Promise.all([
          getHelper(`${baseUrl}/botstatus?rule=ordersCheckerRule`),
          getHelper(`${baseUrl}/settings?setting=general`)
        ]);
        const {state} = ordersCheckerRule.data
        setStopLoss({ ...settings.data, state });
        if(state === 'ENABLED') {
          setSnackbar({ open: true, message: `ScalperBot is active!`, severity: 'info' });
        }
      } catch (error) {
        console.error("Error fetching state:", error);
      }
    }
    fetchGeneralSettings()
  }, []);
  
  const handleStopLossToggle = async (e) => {
    try{
      // Toggle event bridge rule either on or off
      const bodyObject = { 
        ruleName: "ORDERSCHECKER_RULE", 
        newState: stopLoss.state === 'ENABLED' ? 'DISABLED' : 'ENABLED', 
        newDuration: stopLoss.ordersCheckerTimer
      };
      const response = await postHelper(`${baseUrl}/botboss?rule=orderschecker`, bodyObject);
      const { data, message } = response;
      if (!message === 'success') {        
        throw new Error();
      }
      const { state } = data;
      setStopLoss({ ...stopLoss, state });
      const snackMessage = state === 'ENABLED' ? 'orderschecker is active!' : 'orderschecker is inactive!';
      // set snackbar message based on the state
      setSnackbar({ open: true, message: snackMessage, severity: 'success' });
    } catch (error) {
      console.error("Error doing deal:", error);
      setSnackbar({ open: true, message:"Failed to toggle orderschecker state", severity: 'error' });
    }
  }

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChange = async (value, field) => {
    if (isNaN(value) || value < 0 || value > 100) {
      setSnackbar({ open: true, message: `Invalid value for ${field}`, severity: 'error' });
      return;
    }
    const newValues = { ...stopLoss, [field]: value };
    setStopLoss(newValues);
    await postHelper(`${baseUrl}/settings`, newValues);
    setSnackbar({ open: true, message: `Updated ${field} to ${value}`, severity: 'info' });
  };

  return (
    <div>
      {console.log('stopLoss', stopLoss)}
      <h2 className="text-2xl font-bold">Settings</h2>
      <FormControlLabel
        control={
          <Switch
            checked={stopLoss.state === 'ENABLED'}
            onChange={(e) => handleStopLossToggle(e)}
            color="primary"
          />
        }
        label="Toggle Stop/loss"
      />
      <TextField
        label="Stop/loss Timer (minutes)"
        type="number"
        fullWidth
        margin="normal"
        value={parseFloat(stopLoss.ordersCheckerTimer)}
        onChange={(e) => handleChange(parseFloat(e.target.value), "ordersCheckerTimer")}
      />
      <TextField
        label="Stop/loss (percentage)"
        type="number"
        fullWidth
        margin="normal"
        value={parseFloat(stopLoss.ordersCheckerStopLoss)}
        onChange={(e) => handleChange(parseFloat(e.target.value), "ordersCheckerStopLoss")}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
